import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { motion } from "framer-motion";
import Logo from "components/logo";
import { useSite } from "hooks/use-site";
import { LoadingButton } from "@mui/lab";
import { useQuery } from "hooks/use-query";
import { confirmEmail } from "service/api";
import { useDebounceEffect } from "ahooks";
import { useTranslation } from "react-i18next";

const ConfirmEmail = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const [clientId, setClientId] = useState("-");
  const [showPhoneConfirmationButton, setShowPhoneConfirmationButton] =
    useState(false);

  const { logo, frontWalletAuthPageColor } = useSite();

  const { t }: { t: (key: string, opts?: any) => string } = useTranslation();

  useDebounceEffect(
    () => {
      const token = query.get("token");
      if (token) {
        confirmEmail(token).then((res) => {
          if (!res.result) {
            navigate("/signin");
          } else {
            setShowPhoneConfirmationButton(res.showPhoneConfirmationButton);
            setClientId(res.clientId);
          }
        });
      } else {
        navigate("/signin");
      }
    },
    [],
    {
      wait: 0,
    }
  );

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <Container maxWidth="sm">
        <Card elevation={24} component={motion.div} layoutId="auth-card">
          <Box
            paddingY={2.5}
            paddingX={4}
            sx={{ bgcolor: `${frontWalletAuthPageColor}` }}
          >
            <Logo src={logo} />
          </Box>
          <CardContent>
            <Stack spacing={4}>
              <Typography variant="subtitle1">
                {t("auth.confirm_email.email_confirmed")}
              </Typography>

              {showPhoneConfirmationButton && (
                <Typography variant="subtitle1">
                  {t("auth.confirm_email.phone_confirmation")}
                </Typography>
              )}

              <Stack spacing={2}>
                <Box display="flex">
                  {showPhoneConfirmationButton ? (
                    <LoadingButton
                      onClick={() =>
                        navigate(`/mobile-verification?clientId=${clientId}`)
                      }
                      fullWidth
                      variant="contained"
                    >
                      {t("auth.confirm_email.mobile_verification_btn")}
                    </LoadingButton>
                  ) : (
                    <LoadingButton
                      fullWidth
                      variant="contained"
                      onClick={() => navigate("/signin")}
                    >
                      {t("auth.confirm_email.login_btn")}
                    </LoadingButton>
                  )}
                </Box>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default ConfirmEmail;
